import { Link } from 'react-router-dom';
import type { BlogPostMetadata } from '../data/types';
import { trackTagClick } from '../utils/analytics';
import styles from '../styles/FeaturedPost.module.css';

interface FeaturedPostProps {
    post: BlogPostMetadata;
}

function FeaturedPost({ post }: FeaturedPostProps) {
    const handleTagClick = (tag: string) => {
        trackTagClick(tag, 'featured_post');
    };

    return (
        <article className={styles.featured}>
            <Link to={`/blog/${post.slug}`} className={styles.link}>
                <div className={styles.content}>
                    <span className={styles.badge}>Featured</span>
                    <h2>{post.title}</h2>
                    <time dateTime={post.date}>
                        {new Date(post.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}
                    </time>
                    <p className={styles.description}>{post.description}</p>
                    <span className={styles.readMore}>Read more →</span>
                </div>
            </Link>
            {post.tags && post.tags.length > 0 && (
                <div className={styles.tags}>
                    {post.tags.map((tag) => (
                        <Link
                            key={tag}
                            to={`/blog/tag/${encodeURIComponent(tag)}`}
                            className={styles.tag}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleTagClick(tag);
                            }}
                        >
                            {tag}
                        </Link>
                    ))}
                </div>
            )}
        </article>
    );
}

export default FeaturedPost;
